import React from "react";
import DashboardTemplate from "@/components/templates/DashboardTemplate.jsx";
import DashboardContent from "@/components/organisms/DashboardContent.jsx";

function Home() {
  return (
    <DashboardTemplate>
      <DashboardContent />
    </DashboardTemplate>
  );
}

export default Home;
